import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Typography, Button, FormControlLabel, Checkbox } from "@material-ui/core";
import { useStore } from "@store/store";
import Footer from "@components/footer";
import Header from "@components/header";
import Loader from "@components/loader";
import { TermAndConditionStyle } from "./style";
import { getApi, putApi } from "@services/axios";
import {
  getLogin,
  getUserData,
  setUserData
} from "@utils/commonFunctions";
import {
  GET_USER_TERMS,
  GET_USER_TERMS_SUCCESS,
  GET_USER_TERMS_FAILURE,
} from "@utils/actionTypes";
import { routes } from "@utils/constant";
import { setTermsAgreed, getTermsAgreed } from "@utils/commonFunctions";

function TermAndConditionView() {
  const classes = TermAndConditionStyle();
  const history = useHistory();
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [state, dispatch] = useStore();
  const { id } = useParams();
  const isLogin = getLogin();

  const getUserTerms = () => {
    dispatch({ type: GET_USER_TERMS });
    getApi(`users/${id}/terms`)
    .then((response) => {
      dispatch({
        type: GET_USER_TERMS_SUCCESS,
      });

      if (response?.data?.data?.isAgreeTC) {
        history.push(routes.dashboard);
      }
    })
    .catch((error) => {
      dispatch({
        type: GET_USER_TERMS_FAILURE,
      });
      if (error?.response?.status === 404) {
        history.push(routes.pageNotFound);
      }
    });
  }

  const handleAgreeChange = (event) => {
    setTermsAgreed(event.target.checked);
    setAgreed(event.target.checked);
  };

  const handleMessage = (event) => {
    if (event.data?.type === 'scrolledToBottom') {
      setIsScrolledToBottom(true);
    }
  };

  useEffect(() => {
    if (!isLogin && !getUserData()?.isAgreeTC) {
      history.push(routes.login);
    }
    setAgreed(getTermsAgreed());

    if (id) {
      getUserTerms();
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [id]);

  const handleExplore = () => {
    if (agreed) {
      setLoading(true);
      putApi(`/users/update/termsAndConditions`)
        .then(() => {
          // Update localStorage user data with isAgreeTC = true
          const user = getUserData();
          if (user) {
            user.isAgreeTC = true;
            setUserData(user);
          }
          history.push(routes.dashboard, { updatedTermCondition: true });
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(`Error: ${error}`);
        });
    }
  };

  return (
    <>
      <Header isTerms={true}/>
      <div className={classes.commonBannerWrapper}>
        <Loader loading={state.users.loadingUserTerms || loading} />
        <div className="commonBanner">
          <div className={classes.contentWrapper}>
            <div className={classes.root}>
              <Typography variant="h6" className={classes.title}>
                TRADING TERMS & CONDITIONS
              </Typography>
              <Typography variant="subtitle2" color="textSecondary" className={classes.subTitle}>
                Australia and New Zealand
              </Typography>
              <div className={classes.content}>
                <embed
                  src="/terms/wymap_terms_conditions.html"
                  width="100%"
                  height="100%"
                  style={{
                    border: "none"
                  }}
                />
              </div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agreed}
                    onChange={handleAgreeChange}
                    name="agree"
                    disabled={!isScrolledToBottom}
                  />
                }
                label={
                  <Typography variant="body2">
                    I agree to the{' '}
                    <a
                      href="/terms/wymap_terms_conditions_blank.pdf"
                      style={{textDecoration: "underline"}}
                      target="_blank"
                      rel="noopener noreferrer"
                    >terms and conditions</a>
                  </Typography>}
              />
              <div className={classes.actions}>
                <Button
                  variant="contained"
                  className={classes.exploreButton}
                  onClick={handleExplore}
                  disabled={!agreed || !isScrolledToBottom}
                >
                  EXPLORE
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
}

export default TermAndConditionView;
